export const RECONCILE_DOCUMENTS_TABS = {
  PURCHASE_ORDERS: "PURCHASE_ORDERS",
  INVOICES: "INVOICES",
  BACKCHARGES: "BACKCHARGES",
};

export const BACKCHARGES_TAB = "BACKCHARGES_TAB";

export const formatOpenBalanceDisplay = (openBalance) => {
  if (openBalance == null) return "";

  const value = parseFloat(openBalance);

  const formattedCurrency = Math.abs(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: "USD",
    style: "currency",
  });

  if (value < 0) {
    const formattedWithoutSymbol = formattedCurrency.replace(/^\$/, "");
    return `($${formattedWithoutSymbol})`;
  }

  return formattedCurrency;
};
